import moment from 'moment';
import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';
import Experian from '../../assets/img/brands/experian.svg';
import Equifax from '../../assets/img/brands/equifax.svg';
import TransUnion from '../../assets/img/brands/transunion.svg';

const CurrentProcess = ({ cpData, handleChartYearChange, year }) => {
  const [transUnionChecked, setTransUnionChecked] = useState(true);
  const [equifaxChecked, setEquifaxChecked] = useState(true);
  const [experianChecked, setExperianChecked] = useState(true);
  const [transUnionDisabled, setTransUnionDisabled] = useState(false);
  const [equifaxDisabled, setEquifaxDisabled] = useState(false);
  const [experianDisabled, setExperianDisabled] = useState(false);

  React.useEffect(() => {
    const checkIfDataIsNAorZero = () => {
      let transUnion = false,
        equifax = false,
        experian = false;
      for (const month in cpData) {
        if (cpData[month]?.transunion !== 'N/A' && cpData[month]?.transunion !== 0) {
          transUnion = true;
        }
        if (cpData[month]?.equifax !== 'N/A' && cpData[month]?.equifax !== 0) {
          equifax = true;
        }
        if (cpData[month]?.experian !== 'N/A' && cpData[month]?.experian !== 0) {
          experian = true;
        }
      }
      setTransUnionDisabled(!transUnion);
      setEquifaxDisabled(!equifax);
      setExperianDisabled(!experian);
      setTransUnionChecked(transUnion);
      setEquifaxChecked(equifax);
      setExperianChecked(experian);
    };

    checkIfDataIsNAorZero();
  }, [cpData]);

  const handleCheckboxClick = checkboxName => {
    if ((checkboxName === 'TransUnion' && !transUnionDisabled) || (checkboxName === 'Equifax' && !equifaxDisabled) || (checkboxName === 'Experian' && !experianDisabled)) {
      let checkedCount = 0;
      if (equifaxChecked) checkedCount++;
      if (experianChecked) checkedCount++;
      if (transUnionChecked) checkedCount++;

      if (checkedCount > 1) {
        if (checkboxName === 'TransUnion') {
          setTransUnionChecked(!transUnionChecked);
        } else if (checkboxName === 'Equifax') {
          setEquifaxChecked(!equifaxChecked);
        } else if (checkboxName === 'Experian') {
          setExperianChecked(!experianChecked);
        }
      } else {
        if (checkboxName === 'TransUnion') {
          setTransUnionChecked(true);
        } else if (checkboxName === 'Equifax') {
          setEquifaxChecked(true);
        } else if (checkboxName === 'Experian') {
          setExperianChecked(true);
        }
      }
    }
  };

  const options = {
    responsive: true,
    spanGaps: true,
    legend: {
      display: false,
    },

    scales: {
      xAxes: [
        {
          gridLines: {
            color: 'rgba(0, 0, 0, 0)',
            tickBorderDash: [5, 5],
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            color: 'rgba(0, 0, 0, 0)',
          },
          ticks: {
            stepSize: 50,
            max: 850,
            min: 350, // minimum value
          },
        },
      ],
      // stepped: true,
    },
  };
  let graphLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const startingMonth = parseInt(Object.keys(cpData).sort()[0]) - 1;
  graphLabels = graphLabels.splice(startingMonth);
  graphLabels = ['', ...graphLabels];
  const data = {
    labels: graphLabels,
    datasets: [
      {
        id: 1,
        label: 'TransUnion',
        data: transUnionChecked ? graphLabels.map((label, i) => (cpData[i + startingMonth]?.transunion === 'N/A' || cpData[i + startingMonth]?.transunion === 0 || cpData[i + startingMonth]?.transunion < 350 ? null : cpData[i + startingMonth]?.transunion)) : [],
        fill: false,
        borderColor: '#04A5CA',
        tension: 0,
        borderWidth: 3,
        backgroundColor: '#04A5CA',
      },
      {
        id: 2,
        label: 'Equifax',
        data: equifaxChecked ? graphLabels.map((label, i) => (cpData[i + startingMonth]?.equifax === 'N/A' || cpData[i + startingMonth]?.equifax === 0 || cpData[i + startingMonth]?.equifax < 350 ? null : cpData[i + startingMonth]?.equifax)) : [],
        fill: false,
        borderColor: '#9E1B33',
        tension: 0,
        borderWidth: 3,
        backgroundColor: '#9E1B33',
      },
      {
        id: 3,
        label: 'Experian',
        data: experianChecked ? graphLabels.map((label, i) => (cpData[i + startingMonth]?.experian === 'N/A' || cpData[i + startingMonth]?.experian === 0 || cpData[i + startingMonth]?.experian < 350 ? null : cpData[i + startingMonth]?.experian)) : [],
        fill: false,
        borderColor: '#1D4F90',
        tension: 0,
        borderWidth: 3,
        backgroundColor: '#1D4F90',
      },
    ],
  };

  //round_year
  return (
    <React.Fragment>
      <div className='d-flex align-items-center justify-content-between mb-3'>
        <h3>Current Progress</h3>
        <div>
          {/* <select className='form-select border-0 shadow' onChange={(e)=>{handleChartYearChange(e.target.value)}} value={year}>
            <option value={moment().year()-1} >Last year</option>
            <option value={moment().year()}>Current Year</option>
          </select> */}
        </div>
      </div>

      <Card className='border-0 shadow rounded mb-2' style={{ minWidth: '600px' }}>
        <Card.Body>
          <Line datasetIdKey='id' data={data} options={options} />
          <div className='d-flex justify-content-between flex-row w-90 mx-auto'>
            <div className='d-flex justify-content-center align-items-center'>
              <label htmlFor=''>
                <input className='me-2' type='checkbox' checked={equifaxChecked} name='Equifax' value='0' onChange={()=>{}} onClick={() => handleCheckboxClick('Equifax')} disabled={equifaxDisabled} />
                <img src={Equifax} width={80} alt='Equifax' className='ms-3' />
              </label>
              <span className='ms-1'>
                <hr className='rounded-5 opacity-100' style={{ height: '3px', width: '20px', color: '#9E1B33' }} />
              </span>
            </div>
            <div className='d-flex justify-content-center align-items-center'>
              <label htmlFor='Experian'>
                <input className='me-2' type='checkbox' checked={experianChecked} name='Experian' value='1' onChange={()=>{}} onClick={() => handleCheckboxClick('Experian')} disabled={experianDisabled} />
                <img src={Experian} width={80} alt='Experian' className='ms-3' />
              </label>
              <span className='ms-1'>
                <hr className='rounded-5 opacity-100' style={{ height: '3px', width: '20px', color: '#1D4F90' }} />
              </span>
            </div>
            <div className='d-flex justify-content-center align-items-center'>
              <label htmlFor='TransUnion'>
                <input className='me-2' type='checkbox' checked={transUnionChecked} name='TransUnion' value='2' onChange={()=>{}} onClick={() => handleCheckboxClick('TransUnion')} disabled={transUnionDisabled} />

                <img src={TransUnion} width={80} alt='TransUnion' className='ms-3' />
              </label>
              <span className='ms-1'>
                <hr className='rounded-5 opacity-100' style={{ height: '3px', width: '20px', color: '#04A5CA' }} />
              </span>
            </div>
          </div>
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

export default CurrentProcess;
